<template>
  <v-card :disabled="loading" color="info" height="132">
     <v-progress-linear
      v-show="loading"
      color="white"
      indeterminate

    ></v-progress-linear>
    <v-card-text>
      <v-row>
        <v-col cols="4" class="text-title-card">
          <v-icon x-large dark> mdi-package-variant-closed </v-icon>
        </v-col>
        <v-col class="text-right text-title-card">
            <span v-if="error">
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon  color="yellow" v-bind="attrs" v-on="on"> mdi-alert </v-icon>
                    </template>
                    <span>{{errorMessage}}</span>
                </v-tooltip>
            </span>
             ESTOQUE </v-col>
      </v-row>

      <v-row no-gutters class="text-data-card mt-4">
        <v-col>ESTOQUE</v-col>
        <v-col class="text-right">R$ {{ formatMoney(stockValue) }} </v-col>
      </v-row>
      <v-row no-gutters class="text-data-card">
        <v-col cols="8"></v-col>
        <v-col class="text-right"> </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      errorMessage: '',
      error: false,
      stockValue: 0.0,
      loading:false,

    };
  },
  created() {
    //pega o valol total do estock
    this.getData()
  },
  methods: {
    ...mapActions('Dashboard',['getStockValue']),
    getData() {
      this.loading = true
      this.getStockValue().then((response) => {
        this.stockValue = response.data.result
      }).catch(error => {
        if(error.response.status == 423){
          this.errorMessage = error.response.data.message;
          this.error = true;
        }
      }).finally(()=>{
        this.loading = false
      })
    },
    formatMoney(number) {
      number = this.parseNumber(number);
      return number.toLocaleString("pt-br", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    parseNumber(number) {
      if (isNaN(number)) {
        return 0;
      }
      let result = parseFloat(number);
      return result;
    },
  },
};
</script>

<style scoped>
.text-title-card {
  color: white;
  font-size: 20px;
  font-weight: bold;
}
.text-data-card {
  color: white;
  font-size: 14px;
  font-weight: bold;
}
</style>
